const fallbackMessage = 'Something went wrong. Please try again.';

const internalMarkers = [
  'azure',
  'msal',
  'cosmos',
  'blob',
  'jwt',
  'bearer',
  'token',
  'stacktrace',
  'application requested a user session',
  'user session which does not exist',
  'authenticationfailed',
  'server failed to authenticate',
  'authorization header',
  'mac signature',
];

/** Maps an arbitrary client or GraphQL error to approved user-facing copy. */
export function getPublicErrorMessage(error, fallback = fallbackMessage) {
  const message = String(error?.message || error || '').trim();
  if (!message) return fallback;
  const lower = message.toLowerCase();
  if (internalMarkers.some((marker) => lower.includes(marker))) {
    if (lower.includes('sign in') || lower.includes('session') || lower.includes('token')) {
      return 'Please sign in again.';
    }
    return fallback;
  }
  return message;
}

/** Extracts the stable public code from the first GraphQL error, when present. */
export function getGraphQLErrorCode(error) {
  return error?.graphQLErrors?.find((graphQLError) => graphQLError?.extensions?.code)?.extensions?.code
    || error?.networkError?.result?.errors?.find((graphQLError) => graphQLError?.extensions?.code)?.extensions?.code
    || error?.extensions?.code
    || '';
}

/** Returns whether the backend rejected a write because the plan limit was reached. */
export function isLimitReachedError(error) {
  return getGraphQLErrorCode(error) === 'LIMIT_REACHED';
}
